import "script-loader!./jquery-migrate-3.6.0.min.js";
import "script-loader!./lib/jquery-ui-themes/jquery-ui-1.13.2.min.js";
import "script-loader!./jquery.validate.min.js";
import "script-loader!./jquery.validate.unobtrusive.min.js";
